import { withOrientationChange } from "react-device-detect";

interface ComparisonValueProps {
  text: string;
  artistMetric: number;
  lowPerformance: boolean;
  color: string;
  green?: boolean;
  orange?: boolean;
  useRecommendation: boolean;
  recommentation: number;
  fontSize?: number;
  isPortrait?: boolean;
}
const ComparisonValue: React.FC<ComparisonValueProps> = ({
  text,
  artistMetric,
  lowPerformance,
  color,
  green,
  orange,
  useRecommendation = false,
  recommentation,
  isPortrait,
  fontSize = isPortrait ? 12 : 20,
}) => (
  <div className="comparison-value">
    <span
      className={green ? "green" : orange ? "orange" : ""}
      style={{ fontSize }}
    >
      {text}
    </span>
    <span className={`comparison-circle ${lowPerformance ? "red" : color}`}>
      {useRecommendation
        ? recommentation?.toFixed(1)
        : artistMetric?.toFixed(1)}
    </span>
  </div>
);

export default withOrientationChange(ComparisonValue);
